import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';
import { InscriptosActividadService } from '../../services/services.index';
import { User } from '../../models/user.model';
import { URL_SERVICES } from '../../config/config';

import * as XLSX from 'xlsx';

declare var $;

@Component({
  selector: 'app-inscriptos-actividad',
  templateUrl: './inscriptos-actividad.component.html',
  styles: []
})
export class InscriptosActividadComponent implements OnInit {

  inscriptosActividad: any[] = [];
  inscripto: User;
  hideModal2: string = 'hide-modal';

  congresoId: any;

  loading: boolean = true;

  constructor(private activatedRoute: ActivatedRoute, public _inscriptosActividadService: InscriptosActividadService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this.congresoId = congresoId;
      let actividadId: any = params['actividad'];
      this._inscriptosActividadService.getInscriptosActividad(congresoId, actividadId).subscribe(resp => {
        this.loading = false;
        this.inscriptosActividad = resp.insctiptosActividad;
      });
    });
  }

  hideModalMethod() {
    this.hideModal2 = 'hide-modal';
  }

  showModal() {
    this.hideModal2 = '';
  }

  generateExcel() {
    this.loading = true;

    let listadoImprimir: any[] = [];

    let tituloListado: string;
    let inscriptosImprimir: any[];
    let nombreArchivo: string;

    tituloListado = 'Inscriptos en la Actividad: ' + this.inscriptosActividad[0].actividad.nombre_es;
    nombreArchivo = 'actividad';

    inscriptosImprimir = this.inscriptosActividad;

    listadoImprimir.push([tituloListado]);

    listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad']);

    for (let inscripto of inscriptosImprimir) {
      let arrInscripto: any[];
      if (inscripto.uid.socio) {
        arrInscripto = [inscripto.uid.dni, inscripto.uid.name, inscripto.uid.apellido, inscripto.uid.email, inscripto.categoriaInscripcion.nombre_es, inscripto.uid.sociedad];
      } else {
        arrInscripto = [inscripto.uid.dni, inscripto.uid.name, inscripto.uid.apellido, inscripto.uid.email, inscripto.categoriaInscripcion.nombre_es];
      }

      listadoImprimir.push(arrInscripto);
    }

    this.excelMethods(listadoImprimir, nombreArchivo);
  }

  excelMethods(listadoImprimir: any, nombreArchivo: any) {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(listadoImprimir);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inscriptos');

    /* save to file */
    XLSX.writeFile(wb, 'listado-inscriptos-' + nombreArchivo + '.xlsx');
    this.loading = false;
  }

  verInscripcion(inscripto: any, i: number) {
    $('#verTooltip_' + i).tooltip('hide');
    this.inscripto = inscripto;
    this.showModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/inscriptos-actividad/inscriptos-actividad.component.ts